export default "__VITE_ASSET__e84ecffe__"